import { XCircle, ArrowLeft } from 'lucide-react';

export default function PaymentCancelPage() {
  return (
    <div className="min-h-screen svh-canvas flex flex-col items-center justify-center px-4 py-16">
      <div className="w-full max-w-[560px]">
        {/* Brand header */}
        <div className="text-center mb-8">
          <img
            src="/photos/Image.jpeg"
            alt="SV Heinersreuth"
            className="h-14 w-14 rounded-full object-cover mx-auto mb-3 shadow-sm ring-1 ring-black/5"
          />
          <p className="text-[15px] font-bold tracking-tight" style={{ color: 'var(--svh-ink)' }}>
            SV Heinersreuth
          </p>
          <p className="svh-label mt-1">Padel &amp; Tennis</p>
        </div>

        <div className="svh-card svh-card-lg svh-card-raised overflow-hidden">
          <div className="h-1 w-full" style={{ background: 'var(--svh-crest)' }} />
          <div className="p-8 md:p-10">
            <div className="flex items-center justify-center mb-6">
              <div className="w-16 h-16 rounded-full bg-amber-50 flex items-center justify-center">
                <XCircle className="w-8 h-8 text-amber-600" strokeWidth={1.75} />
              </div>
            </div>

            <div className="text-center mb-8">
              <p className="text-[12px] font-bold tracking-[0.16em] uppercase text-amber-700 mb-3">
                Zahlung abgebrochen
              </p>
              <h1 className="svh-h2 mb-4">Ihre Zahlung wurde abgebrochen</h1>
              <p className="svh-body">
                Es wurden keine Beträge abgebucht.
              </p>
            </div>

            <hr className="svh-rule mb-6" />

            <div className="space-y-3">
              <button
                onClick={() => window.history.back()}
                className="svh-btn svh-btn--primary svh-focus w-full"
              >
                <ArrowLeft className="w-4 h-4" />
                Zurück zum Checkout
              </button>
              <button
                onClick={() => window.location.href = '/'}
                className="svh-btn svh-btn--secondary svh-focus w-full"
              >
                Zur Startseite
              </button>
            </div>
          </div>
        </div>

        <p className="svh-meta text-center mt-6">SV Heinersreuth e.V.</p>
      </div>
    </div>
  );
}
